import type { BatchItem } from '@api/hooks/useBatch';
import { Chip, DocumentIcon, Typography } from '@gurupay/gp-ui-library';
import { batchStatusColorConfig } from '@pages/batch-operations/utils.ts';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface BatchMobileListItemProps {
	item: BatchItem;
}

export const BatchMobileListItem = ({
	item: {
		fileName,
		status,
		uploadDate,
		operationsCount,
		resolvedAmount,
		resolvedOperationsCount,
		totalAmount,
		uuid,
	},
}: BatchMobileListItemProps) => {
	const { t } = useTranslation('', { keyPrefix: 'payments.batch.table' });

	return (
		<Link
			className="border border-neutral-100 rounded-lg p-space-16 gap-space-16 flex flex-col"
			to={`/operations/batch/${uuid}`}
		>
			<div>
				<Typography
					className="flex items-center gap-space-8 font-bold break-all"
					level="small-text"
				>
					<DocumentIcon className="text-brand-primary-600 min-w-5" />
					{fileName ? fileName : t('unknownName')}
				</Typography>
				<Chip
					className="capitalize mt-space-8"
					color={batchStatusColorConfig[status]}
					label={t(`paymentStatus.${status.toLowerCase()}`)}
				/>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('uploaded')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{uploadDate}
				</Typography>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('operationsCount')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{resolvedOperationsCount ?? operationsCount}
				</Typography>
			</div>

			<div className="flex flex-col">
				<Typography className="font-medium text-neutral-600" level="small-text">
					{t('totalAmount')}
				</Typography>
				<Typography className="font-bold" level="small-text">
					{resolvedAmount ?? totalAmount}
				</Typography>
			</div>
		</Link>
	);
};
